module.exports = __webpack_public_path__ + "static/media/dk.2449c778.svg";